import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import DropdownSelector from '../components/common/DropDownSelector';
import Text from '../components/common/Text';
import Button from '../components/common/Button';
import HotelLogo from '../components/common/HotelLogo';
import Footer from '../components/common/Footer';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { getHotelInformation, getHotelRooms } from '../redux/reducer/actions';
import { setUrls } from '../redux/reducer/slice';

const GenericQrStartPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { uniqueId, propertyId } = useParams();
  const [selectedRoom, setSelectedRoom] = useState({ value: '', label: '' });
  const hotelInformation = useSelector((state) => state.app.hotelInformation);
  const allRooms = useSelector((state) => state.app.allRooms);
  const urls = useSelector((state) => state.app.urls);

  useEffect(() => {
    dispatch(getHotelInformation({ uniqueId, hotelId: propertyId }));
    dispatch(getHotelRooms({ uniqueId, hotelId: propertyId }));
  }, [dispatch, uniqueId, propertyId]);

  useEffect(() => {
    if (
      selectedRoom
      && selectedRoom.value !== ''
      && selectedRoom.label !== ''
    ) {
      const selectedRoomId = selectedRoom?.value;
      dispatch(
        setUrls({ uniqueId, propertyId, selectedItemId: selectedRoomId }),
      );
    }
  }, [dispatch, uniqueId, propertyId, selectedRoom]);

  if (!hotelInformation.logo && !hotelInformation.color) {
    return (
      <main className="flex min-h-screen flex-col gap-16 py-16">
        <section className="mt-20 text-center">
          <LoadingSpinner message="Loading hotel information" dark />
        </section>
        <div className="mt-auto">
          <Footer />
        </div>
      </main>
    );
  }

  const getRoomLabel = (room) => {
    // Format room labels differently for YoursTruly
    if (uniqueId === 'tIPtkyc' && propertyId === 'THENEW1') {
      return `Room ${room?.name}`;
    }

    return `${room?.name} - ${room?.description}`;
  };

  return (
    <main className="flex min-h-screen flex-col gap-16 py-16">
      <section className="flex flex-col items-center gap-12">
        <HotelLogo />
        <h1 className="my-6 max-w-md text-center font-nunito text-7xl">
          <span>Good to see </span>
          <span className="text-pj-primary-400">YOU</span>
        </h1>
        {allRooms && allRooms.length > 0 && (
          <Text center>Please select your room number below:</Text>
        )}
      </section>
      <section className="flex flex-col gap-8">
        {allRooms && allRooms.length === 0 ? (
          <div className="text-center">
            <LoadingSpinner message="Fetching rooms" />
          </div>
        ) : (
          <>
            <DropdownSelector
              items={allRooms && allRooms.map((room) => ({
                value: room.id,
                label: getRoomLabel(room),
              }))}
              selectedItem={selectedRoom}
              setSelectedItem={setSelectedRoom}
            />
            <Button
              text="Continue"
              variant="primary"
              disabled={selectedRoom.value === ''}
              onClick={() => {
                navigate(urls && urls.startPageUrl);
              }}
            />
          </>
        )}
      </section>
      <div className="mt-auto">
        <Footer />
      </div>
    </main>
  );
};

export default GenericQrStartPage;
